import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from 'src/app/core/services/api.service';
import { Point } from 'src/app/shared/models/point';

@Component({
  selector: 'app-move-points',
  templateUrl: './move-points.component.html',
  styleUrls: ['./move-points.component.scss'],
})
export class MovePointsComponent implements OnInit {
  private readonly api: ApiService = inject(ApiService);
  public form: FormGroup = new FormGroup({
    pointTarget: new FormControl(null, Validators.required),
    positionTarget: new FormControl('before'),
  });
  positionTarget = [
    { label: 'Avant', value: 'before' },
    { label: 'Après', value: 'after' },
  ];
  pointSelected: Point[] = [];
  meetingId: number;
  points: Point[] = [];
  
  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    public toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.pointSelected = this.config.data.pointSelected ? this.config.data.pointSelected : [];
    this.meetingId = this.config.data.meetingId ? this.config.data.meetingId : null;
    this.points = this.config.data.points ? this.config.data.points : [];
    const selectedIds = this.pointSelected.map(p => p.id);
    this.points = this.points.filter(point => !selectedIds.includes(point.id));
  }

  confirm(): void {
    const body = {
      targetPointId: this.form.value.pointTarget.id, 
      pointIds: this.pointSelected.map(p => p.id),
      beforeTarget: this.form.value.positionTarget === 'before' ? true : false
    };
    this.api.movePointInMeeting(this.meetingId, body).subscribe({
      next: () => {
        this.toastr.success('Les points ont été déplacés avec succès !', 'Succès');
        this.ref.close();
      },
      error: () => {
        this.toastr.error('Une erreur est survenue lors du déplacement des points.', 'Erreur');
      }
    });
  }
}
